import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

interface Props {
  mode: "guide" | "mask";
}

export default function ReadingOverlay({ mode }: Props) {
  const [y, setY] = useState(0);

  useEffect(() => {
    const onMove = (e: MouseEvent) => setY(e.clientY);
    window.addEventListener("mousemove", onMove);
    return () => window.removeEventListener("mousemove", onMove);
  }, []);

  if (typeof document === "undefined") return null;

  if (mode === "guide") {
    return createPortal(
      <div
        aria-hidden="true"
        className="pointer-events-none fixed left-0 right-0 z-[9998] h-1 bg-primary shadow-[0_0_0_1px_hsl(var(--background))]"
        style={{ top: y - 2 }}
      />,
      document.body,
    );
  }

  // Mask: dark overlay with transparent strip
  const STRIP = 120;
  return createPortal(
    <>
      <div
        aria-hidden="true"
        className="pointer-events-none fixed inset-x-0 top-0 z-[9998] bg-black/70"
        style={{ height: Math.max(0, y - STRIP / 2) }}
      />
      <div
        aria-hidden="true"
        className="pointer-events-none fixed inset-x-0 bottom-0 z-[9998] bg-black/70"
        style={{ top: y + STRIP / 2 }}
      />
    </>,
    document.body,
  );
}
